import { createStyles, Grid, IconButton, LinearProgress, makeStyles, Theme } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import FormSwitch from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormSwitch";
import DeleteIcon from '@material-ui/icons/Delete';
import { useCollectionPointCheck } from "./useCollectionPointCheck";
import FormTextBox from "../../../yoello-lib/modules/dynamicForms/FormComponents/FormTextBox";
import { useWatch, useFormState } from "react-hook-form";
//@ts-ignore
import { IFieldFormChild } from "../../../yoello-lib/modules/dynamicForms/interfaces/IFieldFormChild";
import { useTranslation } from "react-i18next";

export interface ICollectionPoint {
    id?: string;
    name: string;
    max_number_of_concurrent_orders: number;
    enabled: boolean;
    deleted?: boolean;
}
const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        Iconbutton: {
            color: "#C1CAE1",
            padding: "0.5rem 0 0 1rem",
            transition: "0.2s ease-in-out",
            "&:hover": {
                color: "#A7AEBF"
            },
            "&:active": {
                color: "#9BA0AE"
            }
        },
        extendedIcon: {
            marginRight: theme.spacing(1),
        },
        text: {
            color: theme.palette.error.main,
            fontSize: "0.75rem"
        }
    });
},
);

export function CollectionPointEntity(props: IFieldFormChild) {
    const { keyName, index, disabled, control, onDelete } = props;
    const { checkItem, isLoading } = useCollectionPointCheck();
    const { Iconbutton } = useStyles();
    const { t } = useTranslation();

    const name = `${keyName}.${index}.name`;
    const maxNumber = `${keyName}.${index}.max_number_of_concurrent_orders`;
    const enabled = `${keyName}.${index}.enabled`;
    const id = `${keyName}.${index}.id`;

    const [hideError, setHideError] = useState(false);

    const [idValue, nameValue, enabledValue, numberValue] = useWatch({
        control,
        name: [id, name, enabled, maxNumber]
    });
    const { errors, isValid } = useFormState({
        control,
        name: [name, maxNumber, enabled],
    });

    useEffect(() => {
        if (nameValue && nameValue.length > 0 &&
            numberValue && +numberValue > 0) {
            setHideError(true);

        } else {
            setHideError(false);
        }
    }, [idValue, nameValue, enabledValue, numberValue]);
    async function onDeleteHandler() {
        const isAllowed = await checkItem({
            id: idValue,
            name: nameValue
        }, true);
        if (isAllowed) {
            onDelete();
        }
    }
    async function onDisable(value: any) {
        if (!value) {
            checkItem({
                id: idValue,
                name: nameValue
            })
        }
    }
    function generateErrors() {
        const errorArray: JSX.Element[] = [];
        const nameError = errors[name];
        const numberError = errors[maxNumber];
        if (isValid) return errorArray;
        if (nameError) {
            errorArray.push(<>
                <Grid item xs={9} style={{ color: "red", height: "1.25rem" }}>
                    <div className="formErrors" >
                        {t(nameError.message)}
                    </div>
                </Grid>
                <Grid item xs={3} />
            </>)
        }
        if (numberError) {
            errorArray.push(<>
                <Grid item xs={9} style={{ color: "red", height: "1.25rem" }} >
                    <div className="formErrors" >
                        {t(numberError.message)}
                    </div>
                </Grid>
                <Grid item xs={3} />
            </>)

        }
        return errorArray;
    }
    const newProps={
        ...props,
        errors:props.errors && (Array.isArray(props.errors) ? props.errors[index] : props.errors)
    }
    return <>
        <Grid item xs={4} style={{ margin: "0 -4px" }}>
            <FormTextBox {...newProps} inputProperties={{}} label={undefined as any} data-component-name={"COLLECTION_NAME"} keyName={name} />
        </Grid>
        <Grid item xs={3}>
            <FormTextBox {...newProps} label={undefined as any} keyName={maxNumber} inputProperties={{ type: "number" }} />
        </Grid>
        <Grid item xs={1} style={{}}>
            <FormSwitch {...newProps} label={undefined as any} keyName={enabled} noFloat={true} value={enabledValue} formProps={{ onValueChange: onDisable }} />
        </Grid>
        <Grid item xs={2}>
            {!disabled && <IconButton className={Iconbutton} size="medium"
                onClick={onDeleteHandler} aria-label="delete" color="primary">
                <DeleteIcon fontSize="large" />
            </IconButton>}
        </Grid>
        <Grid item xs={2} />
        {isLoading &&
            <>
                <Grid item xs={9}>
                    <LinearProgress />
                </Grid>
                <Grid item xs={3} />
            </>
        }
        {!hideError && generateErrors()}
    </>

}

export function createCollectionObject() {
    return {
        max_number_of_concurrent_orders: 0,
        enabled: false
    };
}